<template>
    <!--
      The one and only <v-app> in the repo.

      It lives here rather than in each app because Vuetify hangs its layout,
      theme and overlay containers off this element: if every lazy route mounted
      its own, those containers would be recreated on each navigation and
      overlays would leak between apps.
    -->
    <v-app>
        <template v-if="session.isLoading.value">
            <v-main class="d-flex align-center justify-center" style="height: 100vh">
                <div class="text-center">
                    <v-progress-circular indeterminate color="primary" size="48" />
                    <p class="text-body-1 text-medium-emphasis mt-4">Authenticating...</p>
                </div>
            </v-main>
        </template>

        <!--
          The login route renders its own full-height <v-main> and deliberately
          has no app bar: there is no tenant or user to show yet.
        -->
        <router-view v-else-if="isLoginRoute" />

        <template v-else>
            <AppBar />
            <v-main>
                <router-view />
            </v-main>
        </template>
    </v-app>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppBar from './AppBar.vue';
import { useSession } from './session/session';

const session = useSession();
const route = useRoute();

const isLoginRoute = computed(() => route.name === 'login');
</script>

<style>
html,
body {
    margin: 0;
}
</style>
